<template>
    <div style="height: 100%">
        <div id="updatemessage" class="updatemessage">
            <p class="messageheaders">通知标题</p>
            <p class="messageinputheaders">
                <a-input placeholder="放假通知" />
            </p>
            <div class="releaseobject">
                <p class="releaseobject-headline">
                    <span>发布对象</span>
                    <a-input-search
                        placeholder="搜索"
                        style="width: 50%; height: 60%; margin-right: 4%"
                    />
                </p>
                <a-radio-group name="radioGroup" :default-value="0">
                    <a-radio :value="0" @click="sendrole(0), (showtable = 0)">
                        按班级发放
                    </a-radio>
                    <a-radio :value="1" @click="sendrole(1), (showtable = 1)">
                        按人员发放
                    </a-radio>
                    <!-- <a-radio :value="2" @click="sendrole(2)">
                    学生
                </a-radio> -->
                </a-radio-group>
                <publictable
                    class="personnel"
                    :columns="classes"
                    :data2="classese"
                    :Show="true"
                    v-if="showtable == 0"
                ></publictable>
                <publictable
                    class="personnel"
                    :columns="people"
                    :data2="peoples"
                    :Show="true"
                    v-if="showtable == 1"
                ></publictable>
            </div>
            <div class="message-content">
                <p class="releaseobject-headline">
                    <span>消息内容</span>
                </p>
                <!-- <input type="text" style="width:100%;height:90%;border:0;utline: none;"> -->
                <textarea
                    style="
                        width: 100%;
                        height: 80%;
                        border: 0;
                        outline: none;
                        resize: none;
                    "
                ></textarea>
            </div>
            <div class="newmessage-but">
                <a-button
                    style="color: #2eadb5; border: 1px #2eadb5 solid"
                    @click="getback"
                    >取消</a-button
                >
                <a-button
                    type="primary"
                    style="
                        background-color: #2eadb5;
                        margin-right: 2%;
                        border: #2eadb5;
                    "
                    @click="getback"
                    >确定</a-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import publictable from "@/components/Table/Table";

export default {
    name: "Updatemessage",
    data() {
        return {
            showtable: "",
            classes: [
                {
                    title: "班级",
                    dataIndex: "class",
                },
                {
                    title: "学生人数",
                    dataIndex: "number",
                },
            ],
            classese: [
                {
                    class: "临床医学1601班",
                    number: "60人",
                },
                {
                    class: "临床医学1602班",
                    number: "56人",
                },
                {
                    class: "临床医学1602班",
                    number: "56人",
                },
            ],
            people: [
                {
                    title: "学生姓名",
                    dataIndex: "name",
                },
                {
                    title: "所属班级",
                    dataIndex: "class",
                },
            ],
            peoples: [
                {
                    name: "李美玲",
                    class: "临床医学1601班",
                },
                {
                    name: "李美玲",
                    class: "临床医学1601班",
                },
            ],
        };
    },
    components: {
        publictable,
    },
    methods: {
        sendrole(num) {
            console.log(num);
        },
        getback() {
            this.$router.push("/courseContent/Info");
        },
    },
};
</script>

<style lang="stylus" scoped>
.updatemessage
    width: 100%
    height: 96%
    background-color: #FFFFFF
    border-radius: 5px
    // overflow:hidden;
    // background-color pink
.messageheaders
    width: 90%
    margin-top: 2%
    margin-left: 4%
    text-align: left
    font-size: 15px
    letter-spacing: 1px
    font-weight: 700
.messageinputheaders
    width: 90%
    margin-top: 1%
    margin-left: 4%
    text-align: left
    font-size: 15px
    color: #555555
    letter-spacing: 1px
    & input
        width: 100%
        border-color: #888888
        border-radius: 0
.releaseobject
    width: 25%
    height: 70%
    float: left
    // background-color: pink;
    margin-top: 1%
    margin-left: 4%
    border: 1px #dadada solid
    overflow: auto
.message-content
    width: 63%
    height: 70%
    float: left
    border: 1px #dadada solid
    margin-top: 1%
    margin-left: 2%
    float: left
.releaseobject-headline
    width: 100%
    height: 10%
    background-color: #F4F4F4
    display: flex
    justify-content: space-between
    align-items: center
    & span
        color: #2FAEB6
        margin-left: 3%
        font-size: 1.85185185185vh
/deep/.ant-input
    height: 100%
    border-radius: 20px
.releaseobject-headline
    background-color: #F4F4F4
/deep/.ant-radio-group
    height: 10%
    display: flex
    justify-content: space-around
    align-items: center
/deep/.ant-input-search > .ant-input
    display: inline-block
    width: 100%
    font-size: 1.66666666vh
.personnel
    display: inline-block
    width: 100%
    height: 10%
    margin-top: 0
    // overflow-y:scroll
    // display: flex;
    // align-items center
    & li
        width: 15%
        float: left
        margin-right: 17%
.checkbox-input
    width: 16px
    height: 16px
.newmessage-but
    width: 100%
    height: 20%
    float: left
    display: flex
    justify-content: flex-start
    align-items: center
    .ant-btn
        margin-left: 30%
        z-index: 999
</style>